module.exports = __webpack_public_path__ + "img/113-69534f.png";